import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, FormHelperText } from '@bonusly/design-system';

import { NominatedGroup } from '../../../schemas/nominations';
import { useGroupMemberPreview } from '../hooks/use-group-member-preview';

type GroupNomineeMemberFormHelperTextProps = {
	group: NominatedGroup;
};

export const GroupNomineeMemberFormHelperText: FC<GroupNomineeMemberFormHelperTextProps> = ({ group }) => {
	const { t } = useTranslation('nominations', { keyPrefix: 'modal' });
	const { isLoadingMembers, orderedGroupMemberRows, previewLimit, setShowAllGroupMembers, showAllGroupMembers } = useGroupMemberPreview(group);

	return (
		<FormHelperText wordBreak="break-word" cursor="default">
			{group.userIds.length === 0 ? (
				t('groupMemberCount', { count: group.userIds.length })
			) : isLoadingMembers ? (
				<>
					{t('groupMemberCount', { count: group.userIds.length })}
					{': '}
					{t('groupMembersLoading')}
				</>
			) : (
				<>
					{t('groupMemberCount', { count: group.userIds.length })}
					{': '}
					{(showAllGroupMembers ? orderedGroupMemberRows : orderedGroupMemberRows.slice(0, previewLimit)).map((r) => r.label ?? '…').join(', ')}
					{orderedGroupMemberRows.length > previewLimit && (
						<>
							{' '}
							<Button
								variant="link"
								size="sm"
								display="inline"
								verticalAlign="baseline"
								p={0}
								h="auto"
								minH={0}
								minW={0}
								fontWeight="normal"
								fontSize="inherit"
								color="text.interactive"
								textDecoration="underline"
								aria-expanded={showAllGroupMembers}
								onClick={() => setShowAllGroupMembers((v) => !v)}
							>
								{showAllGroupMembers ? t('groupMembersSeeLess') : t('groupMembersSeeMore')}
							</Button>
						</>
					)}
				</>
			)}
		</FormHelperText>
	);
};
